<tax-modal-header data-qa-block="qrcode-header"
  >{{ 'account_payment-methods.qrcode.title' | translate
  }}{{ billingAccountNumber }}</tax-modal-header
>

<tax-modal-content data-qa-block="qrcode-content" class="qrcode-content">
  <span data-qa="qrcode-description"
    >{{ 'account_payment-methods.qrcode.description' | translate }} {{ paymentMethodName }}</span
  >
  <qrcode data-qa="qrcode" [qrdata]="qrcode + billingAccountNumber"></qrcode>
</tax-modal-content>
